import { toast } from 'react-toastify'

import { api } from 'api'
import { Info, Success } from 'constants/actionMessages'
import { RtmParameters } from 'interfaces/api/rtmParameters.interfaces'
import {
  CreateRtmParametersParams,
  RemoveRtmParametersParams,
  UpdateRtmParametersParams,
} from 'interfaces/store/rtmParameters.interfaces'
import { createAction, createAsyncThunk } from 'modules/store'
import { ValidationErrorsApi } from 'packages/api'

export const getAllRtmParameters = createAsyncThunk(
  'rtmParameters/getAllRtmParameters',
  async (_, { rejectWithValue }) => api.rtmParameters.getAll().catch((error) => rejectWithValue(error.message)),
)

export const setRtmParametersValidationErrors = createAction<ValidationErrorsApi | null>(
  'rtmParameters/setRtmParametersValidationErrors',
)

export const createRtmParameters = createAsyncThunk(
  'rtmParameters/createRtmParameters',
  async (params: CreateRtmParametersParams, { rejectWithValue, dispatch }) =>
    api.rtmParameters
      .create(params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setRtmParametersValidationErrors(null))
        toast.success(Success.RtmParametersCreated)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setRtmParametersValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const updateRtmParameters = createAsyncThunk(
  'rtmParameters/updateRtmParameters',
  async (params: UpdateRtmParametersParams, { rejectWithValue, dispatch }) =>
    api.rtmParameters
      .update(params.id, params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setRtmParametersValidationErrors(null))
        toast.success(Success.Save)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setRtmParametersValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const removeRtmParameters = createAsyncThunk(
  'rtmParameters/removeRtmParameters',
  async (params: RemoveRtmParametersParams, { rejectWithValue }) =>
    api.rtmParameters
      .remove(params.id)
      .then(() => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        toast.info(Info.RtmParametersRemoved)
        return
      })
      .catch((error) => rejectWithValue(error.message)),
)

export const setSingleRtmParameters = createAction<RtmParameters | null>('rtmParameters/setSingleRtmParameters')
